__turbopack_context__.v({
  "buttons": "FanaticalPopup-module__M9iezq__buttons",
  "list": "FanaticalPopup-module__M9iezq__list",
  "main": "FanaticalPopup-module__M9iezq__main",
});
